

function TeacherPage() {
  return (
<div>
    <header className="site-header">
        <div className="top-bar">
            <div className="search-icon">
                <i className="bi bi-search"></i>
            </div>
            <a href="/" className="navbar-logo">
                <img src={process.env.PUBLIC_URL + '/images/digimar-LOGO-clean.png'}/>
            </a>
            <div className="user-icons">
                <i className="bi bi-person-circle"></i>
            </div>
        </div>
        <nav className="navbar">
            <ul className="navbar-links">
                <li className="dropdown" id="home">
                    <a href="#" className="dropdown-toggle" id="home" data-bs-toggle="dropdown" role="button" aria-expanded="false">Learning Materials <span className="caret"></span></a>
                    <ul className="dropdown-menu" id="home">
                        <li><a href="/basic">Basic Content</a></li>
                        <li><a href="/advanced">Advanced Content</a></li>
                    </ul>
                </li>
                <li><a href="#">Digital Tools</a></li>
                <li><a href="#">Publications</a></li>
                <li><a href="#">About Us</a></li>
                <li><a href="#">Login</a></li>
            </ul>
        </nav>
    </header>

    <div className="teacher-home-banner">
        <div className="container">
            <h1 className="teacher-title">
                Welcome [Teacher Name]!
            </h1>
            <p>
                Below you will be able to see all students in this course aswell as which exercises have been completed
            </p>
        </div>
    </div>

    <div className="student-table">
        <div className="table-caption">
            List of students
        </div>
        <table class="table table-hover table-dark">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">First name</th>
                    <th scope="col">Last name</th>
                    <th scope="col">Completed exercises</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <th scope="row">1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>Exercise 1</td>
                </tr>
                <tr>
                <th scope="row">2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>Exercise 2, Exercise 4</td>
                </tr>
                <tr>
                <th scope="row">3</th>
                    <td>Larry</td>
                    <td>the Bird</td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>

    <footer className="site-footer">
    </footer>
</div>
  )
}

export default TeacherPage;